import type { DetailEntityFieldsProps } from './DetailEntityFields.types'
import '../CreateEntityForm/CreateEntityForm.css'
import './DetailEntityFields.css'

export function DetailEntityFields({ fields }: DetailEntityFieldsProps) {
  return (
    <div className="create-form-table">
      {fields.map((field, index) => {
        const isLast = index === fields.length - 1
        return (
          <div key={field.label} className={isLast ? 'create-form-row--last' : 'create-form-row'}>
            <div className="create-form-label">{field.label}</div>
            <div className="detail-form-value-cell">{field.value}</div>
          </div>
        )
      })}
    </div>
  )
}
